(() => {
  const CONTROLLER_FLAG = 'data-hormonize-editorial-reviews-js-ready';
  const SECTION_SELECTOR = '.hormonize-editorial-reviews';
  const CAROUSEL_SELECTOR = '[data-hormonize-editorial-reviews-carousel]';

  const instances = new WeakMap();

  class HormonizeEditorialReviewsController {
    constructor(section) {
      this.section = section;
      this.carousel = section.querySelector(CAROUSEL_SELECTOR);
      this.carouselController = null;

      if (this.carousel && window.HormonizeScrollCarouselController) {
        this.carouselController = new window.HormonizeScrollCarouselController(this.carousel, {
          viewportSelector: '.hormonize-editorial-reviews__viewport',
          itemSelector: '.hormonize-editorial-reviews__item',
          paginationSelector: '[data-hormonize-editorial-reviews-pagination]',
          statusSelector: '.hormonize-editorial-reviews__sr-status',
          dotClassName: 'hormonize-editorial-reviews__dot',
          singleClassName: 'is-single',
          slideNoun: 'review',
          slideLabel: 'Review',
          alwaysActive: true,
          loop: true,
          showPagination: false,
          getSlideTitle: (item) =>
            item.querySelector('.hormonize-editorial-reviews__review-title')?.textContent?.trim() || '',
        });
        this.carouselController.init();
      }
    }

    destroy() {
      this.carouselController?.destroy();
      this.carouselController = null;
      this.section = null;
      this.carousel = null;
    }
  }

  function initSection(section) {
    if (!(section instanceof HTMLElement) || !section.matches(SECTION_SELECTOR) || instances.has(section)) {
      return;
    }

    instances.set(section, new HormonizeEditorialReviewsController(section));
  }

  function initSections(root = document) {
    const searchRoot = root instanceof Element || root instanceof Document ? root : document;

    if (searchRoot instanceof Element && searchRoot.matches(SECTION_SELECTOR)) {
      initSection(searchRoot);
    }

    searchRoot.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  function destroySections(root) {
    const searchRoot = root instanceof Element ? root : document;
    const sections = [];

    if (searchRoot instanceof Element && searchRoot.matches(SECTION_SELECTOR)) {
      sections.push(searchRoot);
    }

    searchRoot.querySelectorAll(SECTION_SELECTOR).forEach((section) => {
      sections.push(section);
    });

    sections.forEach((section) => {
      const instance = instances.get(section);

      if (!instance) {
        return;
      }

      instance.destroy();
      instances.delete(section);
    });
  }

  function onSectionLoad(event) {
    initSections(event.target);
  }

  function onSectionUnload(event) {
    destroySections(event.target);
  }

  function bindLifecycleEvents() {
    document.addEventListener('shopify:section:load', onSectionLoad);
    document.addEventListener('shopify:section:unload', onSectionUnload);
    document.addEventListener('shopify:section:reorder', () => {
      destroySections(document);
      initSections(document);
    });
  }

  if (!document.documentElement.hasAttribute(CONTROLLER_FLAG)) {
    document.documentElement.setAttribute(CONTROLLER_FLAG, '');
    bindLifecycleEvents();
  }

  initSections(document);
})();
